module.exports = __webpack_public_path__ + "static/img/UBI.12cae39c.png";